/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcription_ProviderInputs */



/**
* | output |
* | --- |
* | "Transcription Provider" |
*
* @param {Transcription_ProviderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_provider = /** @type {((inputs?: Transcription_ProviderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_ProviderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prestataire de transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkriptionsanbieter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fornitore di trascrizioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поставщик услуг транскрипции")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proveedor de transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转录服务提供商")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文字起こしサービス提供業者")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलेखन प्रदाता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fornecedor de transcrição")
	return /** @type {LocalizedString} */ ("Transcription Provider")
});